<template>
  <div
    style="width: 100%; display: flex; flex-direction: column;"
  >
    <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
      <button @click="$emit('close')" class="btn btn-link p-0 font-weight-bold text-decoration-none d-flex align-items-center">
        <font-awesome-icon icon="chevron-left" class="mr-2" /> Return to the list
      </button>
      <button @click="$emit('close')" class="close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="mb-5">
      <h4>
        <span v-if="info.shortname">{{info.shortname}} ●</span>
        {{info.name}}
        <img
          :src="require(`../../../assets/countries/${info.country}.svg`)"
          alt
          class="bank-card__flag mr-2 mb-1"
        />
        <a :href="info.homepage" target="_blank" v-if="info.homepage">
          <span class="external-link"></span>
        </a>
      </h4>
      <div class="mb-4">
        <span class="mr-4">Legal name: {{info.legal_name}}</span>
        <span class="mr-4" v-if="info.bic">BIC: {{info.bic}}</span>
        <span class="mr-4" v-if="info.objectID">ECB MFI code: {{info.objectID}}</span>
        <div class="mt-2">
          <span class="d-block mb-2" v-if="info.brands && info.brands.length > 1">
            <span class="font-weight-bold">Brands:</span>
            <span>
              {{ showAllBrands ? info.brands.join(', ') : info.brands.slice(0, 5).join(', ') }}
              <template v-if="info.brands.length > 5">
                <button class="btn btn-link btn-sm" @click="showAllBrands = !showAllBrands">
                  {{ showAllBrands ? 'Show less' : `and ${info.brands.length - 5} more` }}
                </button>
              </template>
            </span>
          </span>
          <span class="d-block mb-2" v-if="info.countries && info.countries.length > 1">
            <span class="font-weight-bold">Countries Served Cross-Border:</span>
            <span>
              {{
                showAllCountries
                  ? filteredCountries.map(c => countriesList[c] || c).join(', ')
                  : filteredCountries.slice(0, 5).map(c => countriesList[c] || c).join(', ')
              }}
              <template v-if="filteredCountries.length > 5">
                <button class="btn btn-link btn-sm p-0" @click="showAllCountries = !showAllCountries">
                  {{ showAllCountries ? 'Show less' : `and ${filteredCountries.length - 5} more` }}
                </button>
              </template>
            </span>
          </span>
        </div>
      </div>
      <h5>Integration status</h5>
      <span v-if="!info.connectors && info.wip && info.wip.connectors" class="d-block">
        {{ integrationStatuses[info.wip.connectors] }}
      </span>
      <span v-else-if="!info.connectors" class="d-block text-muted">Not integrated</span>
      <span class="d-block" v-if="info.scopes && info.scopes.length">
        APIs:
        <span
          class="text-uppercase btn btn-link btn-sm pt-0 pb-0 border-0 mt-0 mb-0"
          v-for="(scope, index) in info.scopes"
          :key="`details-${index}`"
        >{{scope}}</span>
      </span>
      <span class="d-block" v-if="info.environments && info.environments.length">
        Environments:
        <span
          class="text-capitalize btn btn-link btn-sm pt-0 pb-0 border-0 mt-0 mb-0"
          v-for="(environment, index) in info.environments"
          :key="`details-${index}`"
        >{{environment}}</span>
      </span>
      <span class="d-block" v-if="info.connectors">Connectors:</span>
      <ul v-if="info.connectors">
        <li v-for="(connector, connectorName, index) in info.connectors" :key="`details-${index}`">
          <span class="font-weight-bold align-middle mr-2">{{connectorName}}</span>
          <ul v-if="info.connectors[connectorName].psuTypes.length > 0">
            <span class="d-block">
              Supported usage:
              <span
            class="text-uppercase btn btn-link btn-sm pt-0 pb-0 border-0 mt-0 mb-0"
            v-for="(psuType, index) in info.connectors[connectorName].psuTypes"
            :key="`details-${index}`"
          >{{psuType}}</span>
            </span>
          </ul>
          <ul v-if="info.connectors[connectorName].paymentTypes.length > 0">
            <span class="d-block">
              Supported payment types:
            <span
            class="text-uppercase btn btn-link btn-sm pt-0 pb-0 border-0 mt-0 mb-0"
            v-for="(paymentType, index) in info.connectors[connectorName].paymentTypes"
            :key="`details-${index}`"
          >{{paymentType}}</span>
            </span>
          </ul>
        </li>
      </ul>
      <div v-if="info.connectors" class="d-flex flex-column flex-md-row align-items-start mt-4">
        <a
          href="https://tilisy.com"
          target="_blank"
          class="btn btn-link px-3 py-2 font-weight-bold mb-2 mb-md-0 mr-md-2 text-primary d-inline-flex align-items-center"
        >
          Try account information service
          <span class="ml-2 external-link" aria-hidden="true"></span>
        </a>
        <router-link
          to="/docs/markets"
          class="btn btn-link px-3 py-2 font-weight-bold text-muted d-inline-flex align-items-center"
        >
          Market specifics
        </router-link>
      </div>
    </div>

    <!--
    <div v-if="info.updates && info.updates.search" class="mb-3">
      <span class="d-block" v-on:click.prevent="isShowInfo = !isShowInfo" v-if="info.updates && info.updates.modificationDate">
        Last update was {{new Date(info.updates.modificationDate).toLocaleDateString()}}
      </span>
      <h6 class="mt-4"><b>{{info.updates.search.title}}</b></h6>
      <p>
        {{info.updates.search.snippet}}
        <a
          :href="info.updates.search.link"
          v-if="info.updates && info.updates.search && info.updates.search.link"
          target="_blank"
          class="btn btn-link btn-sm"
        >Read more <span class="external-link"></span></a>
      </p>
    </div>
    -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BanksListItemBack',
  data() {
    return {
      showAllCountries: false,
      showAllBrands: false,
      apis: {
        ais: 'account information',
        pis: 'payment initiation',
        cof: 'confirmation of funds'
      }
    }
  },
  computed: {
    ...mapState({
      countriesList: state => state.countriesList,
      integrationStatuses: (state) => state.integrationStatuses
    }),
    filteredCountries() {
      return this.info.countries
        ? this.info.countries.filter(c => c !== this.info.country)
        : []
    }
  },
  mounted() {
    document.title = `${this.info.shortname || this.info.name} Open Banking APIs availability and integration status - Enable Banking`
    let description = `Information about ${this.info.shortname || this.info.name} open banking APIs provided in ${this.countriesList[this.info.country]} is not available.`
    if (this.info.open_banking) {
      description = `Information about ${this.info.shortname || this.info.name} open banking APIs in ${this.countriesList[this.info.country]}.`
      const apis = this.info.open_banking.api ? Object.keys(this.info.open_banking.api) : []
      if (apis.length) {
        description += ` PSD2 APIs provided: ${apis.map(api => this.apis[api] || api).join(', ')}.`
      }
      if (this.info.open_banking.status) {
        Object.entries(this.info.open_banking.status).forEach(e => {
          description += ` ${e[0].charAt(0).toUpperCase()}${e[0].slice(1)} API - ${e[1]}.`
        })
      }
    }
    if (this.info.scopes && this.info.scopes.length) {
      description += ` Aggregation core integrations: ${this.info.scopes.join(', ')}.`
    }
    if (this.info.environments && this.info.environments.length) {
      description += ` Environments integrated: ${this.info.environments.join(', ')}.`
    }
    document.head.querySelector('meta[name=description]').content = description
    if (typeof window !== 'undefined' && window.navigator && window.navigator.webdriver) {
      document.dispatchEvent(new Event('prerender-ready'))
    }
  },
  destroyed() {
    document.title = this.$route.meta.title
    document.head.querySelector('meta[name=description]').content = this.$route.meta.description
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
